import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../core/settings/settings.service';
import { ProductSetupChangesService } from '../../core/settings/product-setup-changes.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ProductSetupService } from '../../shared/services/product-setup.service';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  isSearchBarVisible = false;

  constructor(public settings: SettingsService,
              public productSetupService: ProductSetupService,
              private uiChangesService: ProductSetupChangesService) {
  }

  ngOnInit() {
  }
}
